export default "__VITE_ASSET__CCD_RvnW__"